

import { ErrorType } from '../../models/HttpError';
import { ContractConceptRelationship, CreateContractConceptRelationship } from '../../models/Entities/Contracts/ContractConceptRelationship';

export const CONTRACT_CONCEPT_REL_GET_ALL_REQUEST = 'CONTRACT_CONCEPT_REL_GET_ALL_REQUEST';
export const CONTRACT_CONCEPT_REL_GET_ALL_SUCCESS = 'CONTRACT_CONCEPT_REL_GET_ALL_SUCCESS';
export const CONTRACT_CONCEPT_REL_GET_ALL_FAILURE = 'CONTRACT_CONCEPT_REL_GET_ALL_FAILURE';

export interface ContractConceptRelGetAllRequestAction {
  type: typeof CONTRACT_CONCEPT_REL_GET_ALL_REQUEST;
  contractId: number;
  formConcept?: string;
}

export interface ContractConceptRelGetAllSuccessAction {
  type: typeof CONTRACT_CONCEPT_REL_GET_ALL_SUCCESS;
  items: ContractConceptRelationship[];
}

export interface ContractConceptRelGetAllFailureAction {
  type: typeof CONTRACT_CONCEPT_REL_GET_ALL_FAILURE;
  error: ErrorType;
}

export const CONTRACT_CONCEPT_REL_CREATE_REQUEST = 'CONTRACT_CONCEPT_REL_CREATE_REQUEST';
export const CONTRACT_CONCEPT_REL_CREATE_SUCCESS = 'CONTRACT_CONCEPT_REL_CREATE_SUCCESS';
export const CONTRACT_CONCEPT_REL_CREATE_FAILURE = 'CONTRACT_CONCEPT_REL_CREATE_FAILURE';

export interface ContractConceptRelCreateRequestAction {
  type: typeof CONTRACT_CONCEPT_REL_CREATE_REQUEST;
  data: CreateContractConceptRelationship;
}

export interface ContractConceptRelCreateSuccessAction {
  type: typeof CONTRACT_CONCEPT_REL_CREATE_SUCCESS;
  relationShip: CreateContractConceptRelationship[];
}

export interface ContractConceptRelCreateFailureAction {
  type: typeof CONTRACT_CONCEPT_REL_CREATE_FAILURE;
  error: ErrorType;
}

export const CONTRACT_CONCEPT_REL_UPDATE_REQUEST = 'CONTRACT_CONCEPT_REL_UPDATE_REQUEST';
export const CONTRACT_CONCEPT_REL_UPDATE_SUCCESS = 'CONTRACT_CONCEPT_REL_UPDATE_SUCCESS';
export const CONTRACT_CONCEPT_REL_UPDATE_FAILURE = 'CONTRACT_CONCEPT_REL_UPDATE_FAILURE';

export interface ContractConceptRelUpdateRequestAction {
  type: typeof CONTRACT_CONCEPT_REL_UPDATE_REQUEST;
  data: ContractConceptRelationship;
}

export interface ContractConceptRelUpdateSuccessAction {
  type: typeof CONTRACT_CONCEPT_REL_UPDATE_SUCCESS;
  relationship: ContractConceptRelationship[];
}

export interface ContractConceptRelUpdateFailureAction {
  type: typeof CONTRACT_CONCEPT_REL_UPDATE_FAILURE;
  error: ErrorType;
}

export const CONTRACT_CONCEPT_REL_DELETE_REQUEST = 'CONTRACT_CONCEPT_REL_DELETE_REQUEST';
export const CONTRACT_CONCEPT_REL_DELETE_SUCCESS = 'CONTRACT_CONCEPT_REL_DELETE_SUCCESS';
export const CONTRACT_CONCEPT_REL_DELETE_FAILURE = 'CONTRACT_CONCEPT_REL_DELETE_FAILURE';

export interface ContractConceptRelDeleteRequestAction {
  type: typeof CONTRACT_CONCEPT_REL_DELETE_REQUEST;
  id: number;
}

export interface ContractConceptRelDeleteSuccessAction {
  type: typeof CONTRACT_CONCEPT_REL_DELETE_SUCCESS;
  id: number;
}

export interface ContractConceptRelDeleteFailureAction {
  type: typeof CONTRACT_CONCEPT_REL_DELETE_FAILURE;
  error: ErrorType;
}

// Action creators
export const getAllContractConceptFormRelationshipsRequest = (contractId: number, formConcept?: string): ContractConceptRelGetAllRequestAction => ({
  type: CONTRACT_CONCEPT_REL_GET_ALL_REQUEST,
  contractId,
  formConcept,
});

export const getAllContractConceptFormRelationshipsSuccess = (items: ContractConceptRelationship[]): ContractConceptRelGetAllSuccessAction => ({
  type: CONTRACT_CONCEPT_REL_GET_ALL_SUCCESS,
  items,
});

export const getAllContractConceptFormRelationshipsFailure = (error: ErrorType): ContractConceptRelGetAllFailureAction => ({
  type: CONTRACT_CONCEPT_REL_GET_ALL_FAILURE,
  error,
});

export const createContractConceptFormRelationshipRequest = (data: CreateContractConceptRelationship): ContractConceptRelCreateRequestAction => ({
  type: CONTRACT_CONCEPT_REL_CREATE_REQUEST,
  data,
});

export const createContractConceptFormRelationshipSuccess = (relationship: ContractConceptRelationship[]): ContractConceptRelCreateSuccessAction => ({
  type: CONTRACT_CONCEPT_REL_CREATE_SUCCESS,
  relationShip: relationship,
});

export const createContractConceptFormRelationshipFailure = (error: ErrorType): ContractConceptRelCreateFailureAction => ({
  type: CONTRACT_CONCEPT_REL_CREATE_FAILURE,
  error,
});

export const updateContractConceptFormRelationshipRequest = (id: number, data: ContractConceptRelationship): ContractConceptRelUpdateRequestAction => ({
  type: CONTRACT_CONCEPT_REL_UPDATE_REQUEST,
  data: data,
});

export const updateContractConceptFormRelationshipSuccess = (relationships: ContractConceptRelationship[]): ContractConceptRelUpdateSuccessAction => ({
  type: CONTRACT_CONCEPT_REL_UPDATE_SUCCESS,
  relationship: relationships,
});

export const updateContractConceptFormRelationshipFailure = (error: ErrorType): ContractConceptRelUpdateFailureAction => ({
  type: CONTRACT_CONCEPT_REL_UPDATE_FAILURE,
  error,
});

export const deleteContractConceptFormRelationshipRequest = (id: number): ContractConceptRelDeleteRequestAction => ({
  type: CONTRACT_CONCEPT_REL_DELETE_REQUEST,
  id,
});

export const deleteContractConceptFormRelationshipSuccess = (id: number): ContractConceptRelDeleteSuccessAction => ({
  type: CONTRACT_CONCEPT_REL_DELETE_SUCCESS,
  id,
});

export const deleteContractConceptFormRelationshipFailure = (error: ErrorType): ContractConceptRelDeleteFailureAction => ({
  type: CONTRACT_CONCEPT_REL_DELETE_FAILURE,
  error,
});
